import { PropsWithChildren } from 'react';

import { ButtonProps } from '@mui/material';

import { ObjectValues } from 'helpers/types';

export const BUTTON_VARIANTS = {
  DEFAULT: 'default',
  RED: 'red',
} as const;

type IButtonVariants = ObjectValues<typeof BUTTON_VARIANTS>;

export interface ISectionWrapperProps extends PropsWithChildren, ButtonProps {
  sectionTitle?: string;
  buttonText?: string;
  buttonClickHandler?: () => void;
  buttonVariant?: IButtonVariants;
  className?: string;
}
